export default __webpack_public_path__ + "static/media/guava.8db713c3.jfif";